import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, titles } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	databoard: {
		height: 'calc(100vh - 326px)', // Fixed height like TagsTable - finicky but works
		width: '100%',
		background: 'transparent',
	},
	databoardBody: {
		height: '100%',
		overflow: 'auto', // Enable scrolling for load more
		backgroundColor: 'transparent',
		border: 'none',
	},
	dataGrid: {
		width: '100%',
	},
	columnHeader: {
		padding: '12px 16px',
		fontWeight: 600,
		color: titles,
		borderBottom: `1px solid ${charmGray}`,
		backgroundColor: '#fafafa',
	},
	sortTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		cursor: 'pointer',
		':hover': {
			color: brandPrimary,
		},
	},
	sortIcon: {
		transition: 'transform 0.2s ease',
		transform: 'rotate(0deg)',
	},
	sortIconFlipped: {
		transform: 'rotate(180deg)',
	},
	sortMenu: {
		backgroundColor: 'white',
		border: `1px solid ${charmGray}`,
		borderRadius: '4px',
		padding: '8px 0',
		minWidth: '150px',
	},
	sortMenuItem: {
		padding: '8px 16px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	emptyStateContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '200px',
	},
	placeholder: {
		padding: '40px 20px',
		textAlign: 'center',
	},
});
